import { Badge } from "@/ui/base/badge";
import { cn } from "@/nucleo/utilitarios";
import { STATUS_TONE, type StatusTone } from "@/nucleo/statusBadgeTokens";
import { humanizeLabel } from "@/nucleo/displayLabels";

export type StatusVariant =
  | "ativo" | "inativo" | "suspenso" | "bloqueado" | "rascunho" | "pendente"
  | "cancelado" | "renovado" | "extinto" | "expirado" | "rescindido"
  | "em_rescisao" | "assinatura_pendente" | "aprovado" | "rejeitado"
  | "processado" | "pago" | "emitida" | "em_execucao" | "concluida";

/** Mapeia cada status semântico ao tom oficial da pill (fill sólido). */
const STATUS_TO_TONE: Record<StatusVariant, StatusTone> = {
  // success
  ativo: "success",
  aprovado: "success",
  pago: "success",
  concluida: "success",
  // warning
  suspenso: "warning",
  pendente: "warning",
  assinatura_pendente: "warning",
  em_rescisao: "warning",
  em_execucao: "warning",
  // destructive
  bloqueado: "destructive",
  cancelado: "destructive",
  rescindido: "destructive",
  rejeitado: "destructive",
  // info
  processado: "info",
  renovado: "info",
  emitida: "info",
  // neutral
  inativo: "neutral",
  rascunho: "neutral",
  extinto: "neutral",
  expirado: "neutral",
};

interface StatusBadgeProps {
  status: StatusVariant;
  label?: string;
  className?: string;
}

export function StatusBadge({ status, label, className }: StatusBadgeProps) {
  const tone = STATUS_TO_TONE[status] ?? "neutral";
  const text = humanizeLabel(label ?? status);
  return (
    <Badge variant="outline" className={cn("font-medium capitalize", STATUS_TONE[tone], className)}>
      {text}
    </Badge>
  );
}

